import React, { useEffect, useState } from "react";
import ComentariosForm from "./ComentariosForm";
import './comentariosResponse.css'
import { useTranslation } from 'react-i18next'
import { useRating } from "../../../hooks/useRating";
import Modal2 from "../../../components/modal2026/modalAlert";

const ComentariosResponse = ({
    ranking,
    comentarios,
    votos,
    friendlyTag,
    guid,
    titulo
}) => {

    const [t, i18n] = useTranslation("detail_blog");
    const [visibleCount, setVisibleCount] = useState(3);
    const [expandedComments, setExpandedComments] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [hoveredStars, setHoveredStars] = useState(0);
    const [points, setPoints] = useState(0);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [hasVoted, setHasVoted] = useState(false);
    const [localVotos, setLocalVotos] = useState(votos);
    const visibleComments = comentarios.slice(0, visibleCount);
    const [showAlertModal, setShowAlertModal] = useState(false);

    const loadMoreComments = () => {
        setVisibleCount(prev => prev + 40);
        setExpandedComments(true);
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("es-MX", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    useEffect(() => {
        const postId = `post-${friendlyTag}`;

        if (localStorage.getItem(postId) === "true") {
            setHasVoted(true);
        }
    }, [friendlyTag]);

    useEffect(() => {
        setLocalVotos(votos);
    }, [votos]);

    const renderStars = (ranking) => {
        const stars = [];

        for (let i = 1; i <= 5; i++) {

            if (ranking >= i) {
                stars.push("/assets/img2026/icon_full_star.svg");
            }
            else if (ranking >= i - 0.5) {
                stars.push("/assets/img2026/icon_half_star.svg");
            }
            else {
                stars.push("/assets/img2026/icon_empty_star.svg");
            }
        }

        return stars;
    };

    const { data, isLoading, error, successMessage } = useRating(
        formSubmitted ? "/blogs/votar" : null,
        {
            friendly: friendlyTag,
            points
        }
    );

    const handleVote = (value) => {

        const postId = `post-${friendlyTag}`;

        if (localStorage.getItem(postId) === "true") {
            return;
        }

        setHoveredStars(value);
        setPoints(value);
        setFormSubmitted(true);

        localStorage.setItem(postId, "true");

        setHasVoted(true);
        setLocalVotos(prev => prev + 1);
    };

    useEffect(() => {

        if (successMessage) {
            setShowAlertModal(true);
        }

    }, [successMessage]);


    return (
        <>
            <div class="_ngcontent-ng-c1842723448 _nghost-ng-c782873536">

                <section class="comments-feed">

                    <div class="comments-feed__layout">

                        <aside class="comments-feed__cta">

                            <h2>
                                {
                                    hasVoted
                                        ? t('votes.thanks')
                                        : t('votes.did-you-like')
                                }
                            </h2>

                            <div class="comments-feed__rating-row">
                                <div class="_ngcontent-ng-c782873536 _nghost-ng-c937772467">

                                    <div
                                        class="blog-detail-star-rating blog-detail-star-rating--large"
                                    >

                                        {
                                            hasVoted ? (

                                                renderStars(ranking).map((star, index) => (
                                                    <img
                                                        key={index}
                                                        alt="Ranking"
                                                        src={star}
                                                    />
                                                ))

                                            ) : (

                                                [1, 2, 3, 4, 5].map((starValue) => (

                                                    <img
                                                        key={starValue}
                                                        alt="Ranking"
                                                        src={
                                                            hoveredStars >= starValue
                                                                ? "/assets/img2026/icon_full_star.svg"
                                                                : "/assets/img2026/icon_empty_star.svg"
                                                        }
                                                        onMouseEnter={() => setHoveredStars(starValue)}
                                                        onMouseLeave={() => setHoveredStars(0)}
                                                        onClick={() => handleVote(starValue)}
                                                        style={{
                                                            cursor: "pointer"
                                                        }}
                                                    />

                                                ))

                                            )
                                        }

                                    </div>
                                </div>

                            </div>

                            {
                                hasVoted && (
                                    <p class="comments-feed__meta">
                                    </p>
                                )
                            }
                            <p class="comments-feed__meta">
                                <span>{(t('votes.total-votes'))}: {localVotos}</span>

                                <span
                                    aria-hidden="true"
                                    class="comments-feed__meta-divider"
                                ></span>

                                <span>
                                    {(t('votes.ranking'))}: {ranking}
                                </span>
                            </p>

                            {/* 👇 abre modal */}
                            <button
                                type="button"
                                onClick={() => setShowModal(true)}
                            >
                                {(t('votes.opinion'))}
                            </button>

                        </aside>

                        <div
                            class={`comments-feed__list ${expandedComments ? "comments-feed__list_desk" : ""}`}
                        >

                            {visibleComments.map((comentario, index) => (

                                <article key={index} class="comments-feed__item">

                                    <div class="comments-feed__comment-header">

                                        <img
                                            src="/assets/img2026/default_avatar.png"
                                            loading="lazy"
                                            class="comments-feed__comment-avatar"
                                            alt={`Avatar de ${comentario.nombre}`}
                                        />

                                        <div class="comments-feed__comment-meta">
                                            <h3>{comentario.nombre}</h3>

                                            <time>
                                                {formatDate(comentario.fecha)}
                                            </time>
                                        </div>

                                    </div>

                                    <p class="comments-feed__comment-text">
                                        {comentario.comentario}
                                    </p>

                                    {comentario.respuesta && (
                                        <div class="comments-feed__reply">

                                            <div class="comments-feed__reply-body">

                                                <div class="comments-feed__reply-header">

                                                    <img
                                                        src="/assets/img2026/rbs_avatar.png"
                                                        loading="lazy"
                                                        class="comments-feed__reply-avatar"
                                                        alt="Avatar de Ricardo Salinas Pliego"
                                                    />

                                                    <h4>
                                                        {comentario.titulo || "Ricardo Salinas Pliego"}
                                                    </h4>

                                                </div>

                                                <p class="comments-feed__reply-text">
                                                    {comentario.respuesta}
                                                </p>

                                            </div>

                                        </div>
                                    )}

                                </article>
                            ))}

                            {visibleCount < comentarios.length && (
                                <button
                                    type="button"
                                    class="comments-feed__more"
                                    onClick={loadMoreComments}
                                >
                                    {(t('2026.more'))}
                                </button>
                            )}

                        </div>

                    </div>

                </section>

            </div>
            <Modal2
                isOpen={showAlertModal}
                closeModal={() => setShowAlertModal(false)}
                variable1={successMessage}
            />

            {/* 👇 Modal */}
            {showModal && (
                <ComentariosForm
                    guid={guid}
                    titulo={titulo}
                    onClose={() => setShowModal(false)}
                />
            )}
        </>
    );
};

export default ComentariosResponse;